module.exports = __webpack_public_path__ + "img/IMG_8g.0e22bcd5.jpg";